import * as d3 from 'd3'

import { useTheme } from '@mui/material/styles'

import type { PieValueType } from '@mui/x-charts'

import { getFilledArcStartEndAngle, getOutterArcStartEndAngle } from '../../util/finstrongUtils'

interface CustomPieArcProps {
  dialScoreData: PieValueType[]
  dataIndex: number
  arcStartAngle: number
  totalAngularSpan: number
  centerX: number
  centerY: number
  arcRadius: number
  arcColor?: string
  innerArcRadius: number
  outterArcRadius: number
  unitsPerSegment: number
  progressEndAngle: number
  isFinacialStrengthGraph?: boolean
}
export const CustomPieArc = ({
  dialScoreData,
  dataIndex,
  arcColor,
  arcStartAngle,
  totalAngularSpan,
  centerX,
  centerY,
  arcRadius,
  innerArcRadius,
  outterArcRadius,
  progressEndAngle,
  unitsPerSegment,
  isFinacialStrengthGraph,
}: CustomPieArcProps) => {
  const theme = useTheme()
  const gradientSteps = [
    { offset: '13.62%', color: theme.palette.chartMono.chartMono2 },
    { offset: '36.67%', color: theme.palette.chartMono.chartMono3 },
    { offset: '59.72%', color: theme.palette.chartMono.chartMono4 },
    { offset: '83.46%', color: theme.palette.chartMono.chartMono5 },
  ]

  const [outterArcStartAngle, outterArcEndAngle] = getOutterArcStartEndAngle(
    dialScoreData,
    totalAngularSpan,
    arcStartAngle,
    dataIndex,
  )

  const [filledArcStartAngle, filledArcEndAngle] = getFilledArcStartEndAngle(
    outterArcStartAngle,
    outterArcEndAngle,
    dataIndex,
    unitsPerSegment,
    progressEndAngle,
  )

  const outerArcGenerator = d3
    .arc()
    .innerRadius(innerArcRadius)
    .outerRadius(outterArcRadius)
    .startAngle(outterArcStartAngle)
    .endAngle(outterArcEndAngle)
    .padAngle(0.02)
    .cornerRadius(8)

  const fillArcGenerator = d3
    .arc()
    .innerRadius(innerArcRadius)
    .outerRadius(outterArcRadius)
    .startAngle(filledArcStartAngle)
    .endAngle(filledArcEndAngle)
    .padAngle(0.02)
    .cornerRadius(8)

  return (
    <>
      {/* Background segment */}
      <path
        d={outerArcGenerator({} as d3.DefaultArcObject)!}
        fill={isFinacialStrengthGraph ? theme.palette.divider : arcColor}
      />

      {/* Progress segment */}
      {isFinacialStrengthGraph && (
        <path d={fillArcGenerator({} as d3.DefaultArcObject)!} fill="url(#arcGradient)" />
      )}

      <defs>
        <linearGradient
          gradientTransform={`rotate(5, ${centerX}, ${centerY})`}
          gradientUnits="userSpaceOnUse"
          id="arcGradient"
          x1={centerX + arcRadius * 0.8 * Math.cos(Math.PI / 1.35)}
          x2={centerX - arcRadius * 0.8 * Math.cos(Math.PI / 1.35)}
          y1={centerY + arcRadius * 0.8 * Math.sin(Math.PI / 1.35)}
          y2={centerY - arcRadius * 0.8 * Math.sin(Math.PI / 1.35)}
        >
          {gradientSteps.map((eachStep, index) => (
            <stop key={index} offset={eachStep.offset} stopColor={eachStep.color} />
          ))}
        </linearGradient>
      </defs>
    </>
  )
}
